import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import TransmittalDocumentItem from "./TransmittalDocumentItem";

import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const TransmittalDocument = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    submissionValue,
    setSubmissionValue,
    selectHardCopyHandleOpen,
    isNew,
    editable,
    viewFileAction,
    downloadFileAction,
    openFileManagerDialog,
    deleteAtthConfirmAction,
    userStageAction,
  } = props;

  return (
    <Fragment>
      <div>
        <Grid item xs={12}>
          {(isNew || editable) && (
            <Button
              variant="contained"
              color="primary"
              className={classes.formBtn}
              onClick={selectHardCopyHandleOpen}
            >
              Add Attachments
            </Button>
          )}
          <Divider className={classes.divider} />
          <div style={{ width: "100%" }}>
            <TransmittalDocumentItem
              submissionValue={submissionValue}
              setSubmissionValue={setSubmissionValue}
              viewFileAction={viewFileAction}
              downloadFileAction={downloadFileAction}
              openFileManagerDialog={openFileManagerDialog}
              deleteAtthConfirmAction={deleteAtthConfirmAction}
              isNew={isNew}
              editable={editable}
              userStageAction={userStageAction}
            />
          </div>
        </Grid>
      </div>
    </Fragment>
  );
};

export default TransmittalDocument;
